import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    maxHeight: "auto",
    paddingButtom: "10%",
    height: "100vh",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#5675D3",
    },
  },
  divPayung: {
    display: "none",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  payung: {
    height: "15%",
    position: "absolute",
    marginTop: "6%",
    marginLeft: "-8%",
  },
  gelombang: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  houseToko: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  content: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      textAlign: "center",
      marginLeft: "60%",
    },
    [theme.breakpoints.down("951")]: {
      marginLeft: 0,
    },
  },
  boxContent: {
    backgroundColor: "#fff",
    width: "550px",
    height: "400px",
    marginTop: "2%",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      width: "350px",
      height: "auto",
      paddingButtom: "12px",
      marginRight: "20%",
      borderRadius: 5,
      boxShadow: "0px 6px 6px #726e6e73",
    },
    [theme.breakpoints.down("951")]: {
      marginRight: 0,
      marginTop: "5%",
    },
  },
  textContent: {
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20%",
    fontWeight: "bold",

    [theme.breakpoints.up("tablet")]: {
      fontSize: "20px",
      textAlign: "center",
      marginTop: "20%",
      fontWeight: "bold",
    },
  },
  textContent1: {
    fontWeight: "500",
  },
  textContent2: {
    color: "#5675D3",
  },
  textContent3: {
    backgroundColor: "#fff",
    display: "inline-block",
    width: "50%",
    fontSize: 18,
    fontWeight: "bold",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      display: "inline-block",
      width: "50%",
      fontSize: 14,
      fontWeight: "bold",
    },
  },
  garisContent: {
    height: 1,
    width: "2",
    backgroundColor: "grey",
    marginTop: -35,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 50,

    [theme.breakpoints.up("tablet")]: {
      height: 1,
      width: "1",
      backgroundColor: "grey",
      marginTop: -30,
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 20,
    },
  },
  textContent4: {
    marginTop: 30,
  },
  form: {
    marginTop: 90,
    width: "70%",
  },
  textCopyright: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30%",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "0%",
    },
  },
  textCopyrightH5: {
    color: "#5675D3",
    marginTop: 20,

    [theme.breakpoints.up("tablet")]: {
      color: "#fff",
      marginTop: 50,
    },
  },
  formBottom: {
    width: "90%",
    fontSize: 12,
    height: "10%",

    [theme.breakpoints.up("tablet")]: {
      width: "90%",
      height: "7%",
    },
    [theme.breakpoints.down("1015")]: {
      fontSize: 10,
    },
    [theme.breakpoints.down("640")]: {
      fontSize: 16,
    },
    [theme.breakpoints.down("422")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("371")]: {
      fontSize: 12,
    },
  },
}));
export default useStyles;
